// src/auth/reviewsAccess.js
//
// Cine vede si cine poate interveni in ecranul de Recenzii.
//
// Un instructor de tip SUPERIOR primeste exact acelasi ecran ca managerul, dar
// strict in citire: fara editare, fara stergere si fara raspuns in Mesaje.
// Predicatele stau intr-un singur loc pentru ca badge-ul din header si popup-ul
// sa nu poata ajunge la concluzii diferite (badge cu numar, dar lista goala).

import { ALLOW, hasAnyRole, ROLES, normalizeRole } from "./access";
import { isSuperiorInstructorType } from "../constants/instructors";

export function isReviewsStaffViewer(user) {
   return hasAnyRole(user, [...ALLOW.ADMIN, ...ALLOW.MANAGER]);
}

export function isSuperiorInstructorReviewsViewer(user, instructor) {
   if (normalizeRole(user?.role) !== ROLES.INSTRUCTOR) return false;
   return isSuperiorInstructorType(instructor?.instructorType);
}

export function canViewAdminReviews(user, instructor) {
   if (isReviewsStaffViewer(user)) return true;
   return isSuperiorInstructorReviewsViewer(user, instructor);
}

// Raspunsul deschide conversatia cu elevul in Mesaje - o actiune de personal.
export function canReplyToAdminReviews(user) {
   return isReviewsStaffViewer(user);
}

/**
 * Managerul vede toate recenziile, dar in chat poate scrie doar elevilor din
 * grupele lui (StaffChatPopup: restrictToMyGroups = isManagerRole). Butonul
 * „Raspunde" trebuie sa dispara in afara acestui scope, altfel
 * POST /chat/conversations e respins si managerul vede o eroare.
 * Adminul nu e limitat pe grupe.
 */
export function reviewsReplyIsGroupScoped(user) {
   return normalizeRole(user?.role) === ROLES.MANAGER;
}

export function canEditAdminReviews(user) {
   return normalizeRole(user?.role) === ROLES.ADMIN;
}

export function canDeleteAdminReviews(user) {
   return normalizeRole(user?.role) === ROLES.ADMIN;
}
